/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepos.defs.js'
export { main as default } from './getRepos.defs.js'
